export default {
    'diagram4-1-5': {
        's': 'S =The Board is now free to do planning',
        's-a': 'S = Ready to act',
        'c': 'C = It is not set up to do planning',
        'c-a': 'C = Not set up to act',
        'q': 'Q = How do we get set up?',
        'q-a': 'Q = What do?'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/4/4a/diagram5/i18n/en.js